module.exports = __webpack_public_path__ + "static/media/model-125.f1f5646c.png";